export default __webpack_public_path__ + "static/media/A2.5aebda75.jpg";